









import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SettingsCard extends Vue {
  @Prop({ required: true })
  title: string;
}
